"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SITES = exports.SCREENS = exports.COLLECTION_ENDPOINT = void 0;
var COLLECTION_ENDPOINT = exports.COLLECTION_ENDPOINT = 'nmzkjzs.pa-cd.com';
var SITES = exports.SITES = {
  undefined: "undefined",
  startseite: "Startseite",
  ausbildungsnachweise: "Ausbildungsnachweise",
  ausbildungsplan: "Fragen & Aufgaben",
  versetzungsplan: "Versetzungsplan",
  praxisaufgabenoverview: "Praxis-Checklisten",
  wissensportal: "EDEKA next",
  meineazubis: "Meine Organisation",
  benachrichtigungen: "Benachrichtigungen",
  chat: "Chat",
  feedback: "Feedback"
};
var SCREENS = exports.SCREENS = {
  detail: 'detail',
  neu: 'neu',
  bearbeiten: 'bearbeiten',
  einzeln: 'einzeln',
  taetigkeiteinzeln: 'taetigkeit-einzeln',
  anhaenge: 'anhaenge',
  anhangeinzeln: 'anhang-einzeln',
  qualifikationen: 'qualifikationen',
  kommentar: 'kommentar',
  start: 'start',
  informationen: 'informationen',
  aufgabenkapiteluebersicht: 'aufgabenkapitel-uebersicht',
  aufgabenkapiteleinzeln: 'aufgabenkapitel-einzeln',
  abteilungenuebersicht: 'abteilungen-uebersicht',
  startazubi: 'start-azubi',
  startausbilder: 'start-ausbilder',
  berufswechsel: 'berufswechsel',
  aufbauausbildung: 'aufbauausbildung',
  azubiuebersicht: 'azubiuebersicht',
  meineazubis: 'meineazubis',
  meineausbilder: 'meineausbilder'
};